import React from 'react';
import Styles from './table-item-status-styles.scss';
const TableItemStatus = ({ text, type = 'Active' }) => {
    // console.log('TableItemStatus:', type);
    const setClassNameByStatus = (type) => {
        switch (type) {
            case 'Active':
                return Styles.active;
            case 'Deactive':
            case 'Locked':
                return Styles.deleted;
            case 'Invited':
                return Styles.invited;
            case 'Draft':
                return Styles.draft;
            case 'Archived':
                return Styles.archived;
            case 'REFERRAL_FREE':
            case 'REFERRAL_INVITED':
                return Styles.invited;
            case 'REFERRAL_ACCEPTED':
                return Styles.active;
            case 'REFERRAL_SUBSCRIBED':
                return Styles.active;
            default:
                return Styles.active;
        }
    };
    return (React.createElement("div", { className: Styles.tableItemStatusWrap },
        React.createElement("span", { className: setClassNameByStatus(type) }, text)));
};
export default TableItemStatus;
